module.exports = __webpack_public_path__ + "static/media/Icon-TrackTransfer.82090052.png";